import { Header, renderServiceTabs, AppVersionFooter, FloatingNav, BackToTopButton, initBackToTop } from '../../components';
import { getCurrentLanguage, t } from '../../i18n';
import { cleanupMenuView, initMenuView, renderMenuView } from '../../pages/restaurant/menu-view';
import { term } from '../../miniapp-config';
import type { MiniAppService } from '@revio/shared';

export function renderCatalogOrderEngine(service: MiniAppService): string {
  const lang = getCurrentLanguage();
  const serviceId = service?.id || 'shop';
  const svcTitle = typeof service?.label === 'object'
    ? (service.label[lang] || service.label.en || service.label.th)
    : (service?.label || t('appName'));

  const menuHtml = renderMenuView();

  return `
    ${Header(svcTitle, false, true)}
    ${renderServiceTabs('service', serviceId)}
    <div class="page-container" id="catalog-content" style="padding-bottom:100px;">
      ${menuHtml}
      ${AppVersionFooter()}
    </div>
    ${BackToTopButton('catalog')}
    ${FloatingNav()}
  `;
}

export function initCatalogOrderEngine(service: MiniAppService): void {
  const serviceId = service?.id || 'shop';
  initMenuView();
  initBackToTop('catalog');
}
